import { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import * as types from 'constants/actionTypes';

const MultiSelectInput = ({ defaultValues = [], options: propsOptions, name, label, hintText, className }) => {
  const dispatch = useDispatch();

  // Getting state from Redux store
  const { [name]: valueFromStore } = useSelector(state => state.form) || [];

  const [options, setOptions] = useState([]);
  const [values, setValues] = useState([]);
  
  useEffect(() => {
    // Format options from props
    if (propsOptions && propsOptions.length > 0) {
      const formattedOptions = propsOptions.map((item) => ({
        title: item.text || item.name,
        text: item.text || item.name,
        value: item.value.toString(),
      }));
      setOptions(formattedOptions);

      // Determine default values: check props, then Redux, or use empty array
      let initialValues = [];
      
      // Prioritize defaultValues from props
      if (defaultValues && defaultValues.length > 0) {
        initialValues = formattedOptions.filter(option => defaultValues.includes(option.value));
      } else if (valueFromStore && valueFromStore.length > 0) {
        // Fallback to formData from Redux if defaultValues is empty
        initialValues = formattedOptions.filter(option => valueFromStore.includes(option.value));
      }

      // If neither is available, set to empty array
      if (initialValues.length === 0) {
        initialValues = [];
      }

      setValues(initialValues);  // Set the values state accordingly
      dispatch({ type: types.FORM_INPUT, value: initialValues, name });
    }
  }, []);  // Trigger effect when props or valueFromStore changes

  const handleChange = (selectedOption) => {
    console.log("Selected Options:", selectedOption);  // Check if selectedOption is correct
    if (selectedOption !== values) {
      setValues(selectedOption);
      dispatch({ type: types.FORM_INPUT, value: selectedOption, name });
    }
    };

  return (
    <div className={`form-group MultipleSelect hideChips ${className}`}>
      <Autocomplete
        multiple
        size="small"
        id={name}
        options={options}
        value={values}
        disableCloseOnSelect
        onChange={(e, selectedOption) => handleChange(selectedOption)}
        getOptionLabel={(option) => option.text}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps} className="select-list-item">
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={selected}
              />
              {option.title || option.text}
            </li>
          );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="standard" placeholder={values.length === options.length ? "All" : `${values.length} Details selected`} InputLabelProps={{ shrink: true }} />
      )}
    />
    </div>
  );
}

export default MultiSelectInput;